import React, { Component } from 'react';
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import { ConfirmationView, DeclinedView, SignUpCreatePassword, ApplicationProcessingView } from "../subcomponents"
import { SlSectionTitle, SlBusyIndicator, SlButton, SlFormEntryRow } from '../editors';
import { newLoanActions } from "../../_actions";
import { userService, newLoanService, LeadService, workflowService } from "../../_services";
import { workflowConstants } from '../../_constants';

class Confirmation extends Component {
    static displayName = Confirmation.name;

    constructor(props) {
        super(props);
        this.decisionDelay = 2000;
        this.decisionTimeout = 21000;
        this.state = {
            isToggle: false,
            branchDetails: "",
            reachedTimeout: false,
            decision: undefined,
            disclosureMessage: "",
            existingCustomerFlow: false
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getDecision = this.getDecision.bind(this);
    }

    getDecision(userHash, leadId) {
        if (this.state.reachedTimeout) {
            this.setState({ decision: null });
            return;
        }

        newLoanService.getLeadDecision(userHash, leadId).then(decisionResult => {
            let newDecision = decisionResult.data;

            if (newDecision && newDecision.hasDecision) {
                const lang = userService.getUserLanguage().toLowerCase();
                const disclosureMessage = lang === "es" ? this.props.disclosure.spanishText : this.props.disclosure.englishText;

                this.setState({ decision: newDecision, disclosureMessage });
            } else {
                setTimeout(this.getDecision, this.decisionDelay, userHash, leadId);
            }
        });
    }

    componentDidMount() {
        let workflowData = workflowService.getCurrentWorkflowStepData()
        if (workflowData.workflowId === workflowConstants.NEW_LOAN_LOGGED_IN_WORKFLOW) {
            this.setState({ decision: null, existingCustomerFlow: true });
        }
        else if (this.props.UserHash && this.props.LeadId && this.state.decision === undefined) {
            setTimeout(() => this.setState({ reachedTimeout: true }), this.decisionTimeout);
            setTimeout(this.getDecision, this.decisionDelay, this.props.UserHash, this.props.LeadId);
        } else {
            this.setState({ decision: null });
        }
    }

    handleClick(e) {
        this.setState({ isToggle: !this.state.isToggle });
    }

    handleSubmit() {
        
        const { dispatch } = this.props;

        dispatch(newLoanActions.confirmation());
    }

    render() {

        if (this.state.existingCustomerFlow) {
            return <ConfirmationView sunLoanBranchId={this.props.BranchId} onDone={this.handleSubmit} />
        }

        if (this.state.decision === undefined) {
            return <ApplicationProcessingView />
        } 

        if (this.state.decision !== null && this.state.decision.status === LeadService.LEAD_DECLINED) {
            return <DeclinedView disclosure={this.state.disclosureMessage} />
        }

        if (this.state.decision !== null && this.state.decision.targetLoan > 0) {
            return <SignUpCreatePassword preapprovedAmount={this.state.decision.targetLoan} requestedAmount={this.state.decision.requestedAmount} />
        }

        return <SignUpCreatePassword />
    }
}


function mapStateToProps(state) {
    const { error, errorString, BranchId, LeadId, UserHash } = state.newLoan;
    const { disclosure, language } = state.users;

    return {
        error, errorString, BranchId, LeadId, UserHash, disclosure, language
    };
}

const connectedConfirmation= connect(mapStateToProps)(Confirmation);
export { connectedConfirmation as Confirmation };


// WEBPACK FOOTER //
// ./src/components/subcomponents/Confirmation.js